<template>
  <div class="return-costs">
    <Separator />
    <div class="return-costs-slider">
      <div class="background">
        <div class="price-card">
          <countTo
            :prefix="'€'"
            :startVal="price"
            :endVal="newPrice"
            :duration="1000"
            :decimals="2"
            :decimal="','"
            class="count-to"
          />
          <PriceCardIcon class="price-card-icon" />
        </div>
        <CloudLeft class="cloud cloud-left" />
        <CloudRight class="cloud cloud-right" />
      </div>
      <flickity
        class="slides"
        ref="flickity"
        :options="flickityOptions"
      >
        <component
          v-for="(slide, index) in slides"
          :key="index"
          :is="slide.component"
          v-bind="slide"
        />
      </flickity>
      <div :class="contentClasses">
        <h3>{{ title }}</h3>
        <p>{{ description }}</p>
      </div>
    </div>
    <Separator />
  </div>
</template>

<script>
import Flickity from 'vue-flickity'
import countTo from 'vue-count-to'
import Slide from './Slide'
import { FirstSlide, SecondSlide, ThirdSlide, FourthSlide, FifthSlide } from './slides'
import Separator from './Separator'
import { CloudLeft, CloudRight, PriceCardIcon } from './icons'

export default {
  name: 'ReturnCosts',
  data () {
    return {
      flickityOptions: {
        prevNextButtons: true,
        pageDots: true,
        wrapAround: false,
        imagesLoaded: true,
        dragThreshold: 10
      },
      price: 0,
      newPrice: 6.25,
      title: 'Verzending',
      description: 'Inpakken kost €2,50 en bezorgen €3,75. Als je het pakje terugstuurt, maakt een bedrijf die kosten voor niets.',
      contentSwap: false,
      slides: [{
        component: FirstSlide,
        price: 6.25,
        title: 'Verzending',
        description: 'Inpakken kost €2,50 en bezorgen €3,75. Als je het pakje terugstuurt, maakt een bedrijf die kosten voor niets.'
      }, {
        component: SecondSlide,
        price: 10,
        title: 'Retour sturen',
        description: 'Je pakket maakt de omgekeerde route terug naar het distributiecentrum. Extra vervoerskosten.'
      }, {
        component: ThirdSlide,
        price: 11.35,
        title: 'Inspectie',
        description: 'Iemand checkt of jouw retour weer de winkel in kan, controleert het artikel en verwerkt dat in het systeem.'
      }, {
        component: FourthSlide,
        price: 12.1,
        title: 'Netjes maken',
        description: 'Haren verwijderen, rits sluiten, veters strikken en knopen vastmaken.'
      }, {
        component: FifthSlide,
        price: 12.5,
        title: 'Distributie',
        description: 'Als laatste: netjes opvouwen, nieuwe verpakking en weer terug op voorraad.'
      }]
    }
  },
  components: {
    Flickity,
    countTo,
    Slide,
    Separator,
    CloudLeft,
    CloudRight,
    PriceCardIcon
  },
  mounted () {
    this.$refs.flickity.on('change', index => {
      this.slideChange(index)
    })
  },
  methods: {
    slideChange (index) {
      const el = this.$refs.flickity.$children[index]
      this.price = this.newPrice
      this.newPrice = el.$props.price
      this.contentSwap = true
      setTimeout(() => {
        this.title = el.$props.title
        this.description = el.$props.description
        this.contentSwap = false
      }, 300)
    }
  },
  computed: {
    contentClasses () {
      return {
        'content': true,
        'swap': this.contentSwap
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.return-costs-slider {
  position: relative;
  margin: 75px auto 2em;
  width: 100%;
  max-width: 500px;
}

.background {
  width: 275px;
  height: 275px;
  border-radius: 50%;
  background-color: #918573;
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 0;
}

.price-card {
  position: absolute;
  left: 42px;
  top: -45px;
}

.slides {
  z-index: 7;
}

.content {
  color: white;
  width: 300px;
  text-align: center;
  display: block;
  margin: 0 auto;
  transition: all 300ms cubic-bezier(0.19, 1, 0.22, 1);
  transform: translateY(0);
  position: absolute;
  left: 0;
  right: 0;
  top: 310px;
  z-index: 1;

  h3,
  p {
    margin: 0;
  }
}

.swap {
  opacity: 0;
  transform: translateY(5px);
}

.count-to {
  position: absolute;
  top: 24px;
  left: 50px;
  line-height: 1;
  width: 102px;
  text-align: center;
  font-size: 32px;
  color: white;
  font-weight: $fw-bold;
  transform: rotate(-12deg);
}

@keyframes clouds {
  from,
  to {
    transform: scale(1);
  }
  50% {
    transform: scale(0.95);
  }
}

.cloud {
  position: absolute;
}

.cloud-left {
  left: -12px;
  top: 51px;
  animation: clouds 3s linear infinite;
}

.cloud-right {
  right: -12px;
  top: 15px;
  animation: clouds 2.5s linear infinite 1s;
}
</style>
<style lang="scss">
.return-costs {
  .flickity-button {
    &.previous {
      left: 10px;
    }

    &.next {
      right: 10px;
    }
  }

  .flickity-button-icon {
    fill: $c-brown;
  }
}
</style>
